import { Box, Center, Text, useColorModeValue } from '@chakra-ui/react'

interface NoDataTextProps {
  noDataText: string
  maxWidth?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textAlign?: any
  title?: string
}

export const NoDataText = ({
  noDataText,
  maxWidth = '',
  textAlign = '',
  title = '',
  ...rest
}: NoDataTextProps) => {
  const bg = useColorModeValue('white', 'black.100')

  return (
    <Box bg={bg} width="100%" padding={8} borderRadius="18px" {...rest}>
      {title && (
        <Text
          color="gray.400"
          fontSize="24px"
          fontWeight="500"
          textAlign={textAlign}
          mb={2}
        >
          {title}
        </Text>
      )}
      <Center>
        <Text
          fontSize={'sm'}
          fontWeight="600"
          textAlign={textAlign}
          maxW={maxWidth}
        >
          {noDataText}
        </Text>
      </Center>
    </Box>
  )
}
